var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"goldenP"},[_c('img',{staticStyle:{"width":"14px","margin-top":"-4px"},attrs:{"src":require("@/assets/blackStar.png"),"alt":""}}),_vm._v(" "+_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }